import api from "./Api";

class MotoristaTelefoneService {
  GetMotoristaTelefone(payload) {
    return api.get("/v1/motoristaTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostMotoristaTelefone(payload) {
    return api.post("/v1/motoristaTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutMotoristaTelefone(payload) {
    return api.put("/v1/motoristaTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteMotoristaTelefone(payload) {
    return api.delete("/v1/motoristaTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetMotoristaTelefoneOData(payload) {
    return api.get("/OData/MotoristaTelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new MotoristaTelefoneService();
